import ApiService from './ApiService';
import AuthService from './AuthService';
import LangService from '../LangService';

class InfoService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = LangService.getDefaultLocale();
        this._attributesCategoryUrl = '/info/attributes/category';
        this._popularAttributesUrl = '/info/attributes/popular';
        this._categoryMainUrl = '/info/category/main';
        this._categorySubUrl = '/info/category/sub';
        this._categoryManufacturersUrl = '/info/category/manufacturers';
        this._categoryPacksUrl = '/info/category/packs';
        this._creditGuarantiesUrl = '/info/order/guaranties';
        this._mainInfoUrl = '/info/main-info';
        this._textPageUrl = '/info/text-page';
        this._quantityUnitsUrl = '/info/general/quantity-units'
    }

    getAttributesCategory(id) {
        return this.postResource(this._attributesCategoryUrl, {categoryID: id}, this.getLangHeader())
    }

    getPopularAttributes() {
        return this.postResource(this._popularAttributesUrl, {}, this.getLangHeader());
    }

    getMainCategories() {
        return this.postResource(this._categoryMainUrl, {}, this.getLangHeader());
    }

    getSubCategories(parentId) {
        return this.postResource(this._categorySubUrl, {categoryID: parentId}, this.getLangHeader())
    }

    getCategoryManufacturers(categoryId) {
        return this.postResource(this._categoryManufacturersUrl, {categoryID: categoryId}, this.getLangHeader())
    }

    getCategoryPacks(parentId) {
        return this.postResource(this._categoryPacksUrl, {categoryID: parentId}, this.getLangHeader())
    }

    getTextPage(systemName) {
        return this.postResource(this._textPageUrl, {systemName}, this.getLangHeader());
    }

    getCreditGuaranties() {
        return this.getResource(this._creditGuarantiesUrl, {headers: this.getLangHeader()});
    }

    getMainInfo() {
        return this.postResource(this._mainInfoUrl, {}, this.getLangHeader());
    }

    getQuantityUnits() {
        return this.postResource(this._quantityUnitsUrl, {}, this.getLangHeader())
    }
}

const Service = new InfoService(AuthService);

export default Service;
